import {
  Button 
} from "@/components/ui/button";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from "@/components/ui/form";
import {
  Input 
} from "@/components/ui/input";
import {
  ResponsiveModal,
  ResponsiveModalContent
} from "@/components/ui/responsive-modal";
import Image from "next/image";
import {
  useFormContext 
} from "react-hook-form";
import {
  ProductRoot 
} from "../types/product";


export const HasCustomizationOptionsDialog = ({
  image,
  product,
  isCustomizationsDialogOpen,
  setIsCustomizationsDialogOpen,
  onSubmit
}: {
    image: any,
    product: ProductRoot,
    isCustomizationsDialogOpen: boolean,
    setIsCustomizationsDialogOpen: any,
    onSubmit: any
}) => {

  const form = useFormContext();

  const data = form.watch()

  return <ResponsiveModal open={isCustomizationsDialogOpen} onOpenChange={setIsCustomizationsDialogOpen}>
    <ResponsiveModalContent className='lg_w-[1000px] lg_max-w-[1000px]' side='right'>
      <div className='lg_flex-row flex flex-col justify-between gap-[50px]'>
        {image && (
          <Image
            src={image.file}
            width={355}
            height={521}
            alt=''
          />
        )}
        <div className='grow'>
          <h2 className='text-primary text-[26px] uppercase'>{product.name}</h2>
          <FormField
            control={form.control}
            name='robes_gifts_customization'
            render={({
              field 
            }) => (
              <FormItem>
                <FormLabel>Letter</FormLabel>
                <FormControl>
                  <Input placeholder='' {...field} />
                </FormControl>
                <FormMessage id='robes_gifts_customization' />
              </FormItem>
            )}
          />
          <Button
            className='mt-[40px] h-[40px]'
            onClick={async () => {
              await onSubmit(data)

              setIsCustomizationsDialogOpen(false)
            }}
          >
                        Preview & Add to cart
          </Button>
        </div>
      </div>
    </ResponsiveModalContent>
  </ResponsiveModal>
}
